import { MouseEventHandler } from 'react';

export const stopBubbling: MouseEventHandler = e => e.stopPropagation();
